import React, { Component } from 'react';

class NotFound extends Component {
    componentWillMount() {
        window.location.href = '/login';
    }

    render() {
        return <div />;
    }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js